import Swiper, { Navigation, Pagination } from 'swiper';

export default class DateSwiper {
  constructor(element) {
    this.el = element
    this.swiper = this.el.querySelector(".swiper")
    this.init()
  }

  init() {
    const swiper = new Swiper(this.swiper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        700:{
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      }     
    });
  }
}